import React, {useState, useEffect} from 'react' 
import { useSelector, useDispatch } from 'react-redux';
import { setCurrentPage, setOrder, setOrderBy,setRowsPerPage} from 'reducers/paginationPurchaseSignatureSlice';
import { Link } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import Box from '@mui/material/Box'; 
import DrawIcon from '@mui/icons-material/Draw'; 
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Paper from '@mui/material/Paper';
import PrintIcon from '@mui/icons-material/Print';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import useTheme from '@mui/material/styles/useTheme';
import visuallyHidden from '@mui/utils/visuallyHidden'; 
import { NumericFormat } from 'react-number-format';
import "css/customDialog.css";
import PropTypes from 'prop-types';

const headCellsPurchaseDelivery = [
  { id: 'purchasenote', numeric: false, disablePadding: false, label: 'Text_NumberPurchase', canOrder: true },
  { id: 'numberticket', numeric: false, disablePadding: false, label: 'Text_PURCHASEDELIVERY_TICKET', canOrder: true },
  { id: 'datepurchase', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_Date', canOrder: true },
  { id: 'ori_tras_tradename', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_STORE', canOrder: true },
  { id: 'workplace', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_WORKPLACE', canOrder: true },
  { id: 'rel_trans_tradename', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_TRADENAME_TRANS', canOrder: true },
  { id: 'vehiclestore_licenseplate', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_LICENSEPLATE', canOrder: true },
  { id: 'totalpurchase', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_TOTAL', canOrder: true } ,
  { id: 'payment_name', numeric: false, disablePadding: false, label: 'Text_PurchaseDeliver_Payment', canOrder: true }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}
  
function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
          return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t} = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          key='edit'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#e74a3b", fontSize: 16}} >
            {t('Button_Sign')}
          </Typography>
        </TableCell>
        <TableCell
          key='print'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#067330", fontSize: 16}} >
            {t('Button_Print')}
          </Typography>
        </TableCell>
        {headCellsPurchaseDelivery.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}  
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilterSignature,numTotRegPurchaseSignature, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilterSignature).toLocaleString('de-DE')} {textOf} {(numTotRegPurchaseSignature).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataPurchases']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingPurchaseDelivery =(props)=>{
  const { 
    dataPurchaseSignature,  
    numTotRegFilterSignature,
    titleTable,
    setRowEditPurchaseSignature,
    numTotRegPurchaseSignature,
    activeOffsetPurchaseSignature,
    rangeOffsetPurchaseSignature,
    currencyOffsetPurchaseSignature,
    setCurrencyOffsetPurchaseSignature,
    setViewPDF
  } = props;
  const {t,i18n} = useTranslation(['listDataPurchases']);
  const dispatch = useDispatch();
  const { currentPage, order, orderBy,rowsPerPage} = useSelector((state) => state.paginationSignature);
  const [countData,setCountData] = useState(dataPurchaseSignature.length);
  const maxPage = Math.max(0, Math.ceil(countData / rowsPerPage) - 1);
  const page = Math.min(currentPage, maxPage);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataPurchaseSignature.length) : 0);
  
  useEffect(
    () => {
      if (dataPurchaseSignature.length!==countData || dataPurchaseSignature.length<=rowsPerPage){
        //setPage(0);
      }  
      setCountData(dataPurchaseSignature.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataPurchaseSignature.length) : 0);  
    },
    [dataPurchaseSignature,page,setEmptyRows,rowsPerPage,countData]
  );

  const handleChangeOffset = (event) => {
    setCurrencyOffsetPurchaseSignature(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    dispatch(setOrder(isAsc ? 'desc' : 'asc')); // Actualiza Redux
    dispatch(setOrderBy(property)); // Actualiza Redux
  };  

  const handleChangePage = (event, newPage) => {
    dispatch(setCurrentPage(newPage)); // Guardar la página actual en Redux
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    dispatch(setRowsPerPage(newRowsPerPage)); // Guardar el número de elementos por página actual en Redux
    dispatch(setCurrentPage(0)); // Reiniciar la página cuando cambian las filas por página
  };
 
  const openModalSignaturePDF = async (row) => {
    setRowEditPurchaseSignature(row);
    setViewPDF(true);
  }; 
  
  const listItems = stableSort(dataPurchaseSignature, getComparator(order, orderBy))
   .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
   .map((row, keyData) => {
    return (
      <TableRow hover tabIndex={-1} key={keyData}>
       
        <TableCell align="center">
          <Link  to={`/purchasesignaturedetails/${row.id}`} >
            <IconButton size="large" className="delete-icon-button">
              <DrawIcon style={{fontSize: 28}}/>
            </IconButton> 
          </Link>
        </TableCell>
        <TableCell align="center">
          <IconButton size="large" className="tickets-icon-button" onClick={()=>openModalSignaturePDF(row)}>
            <PrintIcon style={{fontSize: 28}}/>
          </IconButton>  
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#4e73df", fontSize: 18, textDecorationLine: row.enabled?'':'line-through'}} >
            {row.purchasenote}
          </Typography>  
        </TableCell> 
        <TableCell align="center">
         <Typography style={{color:"#000000", fontSize: 18, textDecorationLine: row.enabled?'':'line-through'}} >
            {(row.numberticket!==undefined && row.numberticket!=="" && row.numberticket!=="0" && row.numberticket!==0)?row.numberticket:""}
          </Typography>
        </TableCell> 
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 18, textDecorationLine: row.enabled?'':'line-through'}} >
          {row.datepurchase !== null &&  row.datepurchase !== ""
            ? new Date(row.datepurchase).toLocaleDateString(i18n.language === "es" ? "es-ES" : "en-US") 
            : ""}
          </Typography>
        </TableCell>
        
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16, textDecorationLine: row.enabled?'':'line-through'}} >
            {row.ori_tras_tradename}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16, textDecorationLine: row.enabled?'':'line-through'}} >
            {row.workplace}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16, textDecorationLine: row.enabled?'':'line-through'}} >
            {row.rel_trans_tradename}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 18, textDecorationLine: row.enabled?'':'line-through'}} >
            {row.vehiclestore_licenseplate}
          </Typography>
        </TableCell>
        <TableCell className="cell-total">
          <NumericFormat
            thousandSeparator=","
            decimalSeparator="."
            decimalScale= {2}
            fixedDecimalScale 
            allowNegative= {false}
            id="totalpurchase"
            name="totalpurchase" 
            value={row.totalpurchase}
            className="numeric-field numeric-field--disabled numeric-field--wide"
            disabled
          /> 
        </TableCell>  
        <TableCell align="left">
          <Typography style={{color:"#000000", fontSize: 16, textDecorationLine: row.enabled?'':'line-through'}} >
            {i18n.language==='es'?row.payment_namees:row.payment_nameen}
          </Typography>
        </TableCell> 
      </TableRow>
    );
  });
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilterSignature={numTotRegFilterSignature} numTotRegPurchaseSignature={numTotRegPurchaseSignature} textOf={t('Text_Of')}/>
          <TableContainer component={Paper} className="formdi-table-container" sx={{ maxHeight: 1400 }}>
            <Table sx={{ minWidth: '750px' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t}/>
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={12} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetPurchaseSignature && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField
                            id="currencyOffsetPurchaseSignature"
                            name="currencyOffsetPurchaseSignature"
                            value={currencyOffsetPurchaseSignature}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetPurchaseSignature
                            }}>
                            {rangeOffsetPurchaseSignature.map((option) => (
                              <option key={option.value} value={option.value}>
                                {option.label}
                              </option>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={12}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingPurchaseDelivery.propTypes = {
  dataPurchaseSignature: PropTypes.array.isRequired,  
  numTotRegFilterSignature: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired,  
  setRowEditPurchaseSignature: PropTypes.func.isRequired,     
  numTotRegPurchaseSignature: PropTypes.number.isRequired,
  activeOffsetPurchaseSignature: PropTypes.bool.isRequired,
  rangeOffsetPurchaseSignature: PropTypes.array.isRequired,
  currencyOffsetPurchaseSignature: PropTypes.number.isRequired,
  setCurrencyOffsetPurchaseSignature: PropTypes.func.isRequired, 
  setViewPDF: PropTypes.func.isRequired
};
  
export default TableSortingPurchaseDelivery;
